export { SvgIcon } from "./SvgIcon";
export { SvgIconProps } from "./SvgIcon";
export { SvgIcon as default } from "./SvgIcon";
